export const addSubmissionDraftAction = (draft) => ({
  type: "ADD_SUBMISSION_DRAFT",
  payload: draft,
});

export const clearSubmissionDraftAction = (assignmentId) => ({
  type: "CLEAR_SUBMISSION_DRAFT",
  payload: assignmentId,
});

export const createSubmissionAction = (submission) => ({
  type: "CREATE_SUBMISSION",
  payload: submission,
});

export const editSubmissionAction = (submission) => ({
  type: "EDIT_SUBMISSION",
  payload: submission,
});

export const fetchSubmissionsAction = (submissions) => {
  const filteredSubmissions = submissions?.filter(
    (submission) =>
      submission.isDraft === undefined || submission.isDraft === false
  );
  return {
    type: "FETCH_SUBMISSIONS",
    payload: filteredSubmissions,
  };
};

export const fetchGroupSubmissionsAction = (submissions) => {
  const filteredSubmissions = submissions?.filter(
    (submission) =>
      submission.isDraft === undefined || submission.isDraft === false
  );
  return {
    type: "FETCH_GROUP_SUBMISSIONS",
    payload: filteredSubmissions,
  };
};

export const fetchPracticeSubmissionsAction = (submissions) => {
  const filteredSubmissions = submissions?.filter(
    (submission) =>
      submission.isDraft === undefined || submission.isDraft === false
  );
  return {
    type: "FETCH_PRACTICE_SUBMISSIONS",
    payload: filteredSubmissions,
  };
};

export const updatePracticeSubmissionAction = (submission) => {
  return {
    type: "UPDATE_PRACTICE_SUBMISSION",
    payload: submission,
  };
};

export const deletePracticeSubmissionAction = (id) => {
  return {
    type: "DELETE_PRACTICE_SUBMISSION",
    payload: id,
  };
};

export const invalidateSubmissionsCache = () => {
  return {
    type: "INVALIDATE_SUBMISSIONS_CACHE",
  };
};
